<script>
import Modal from "./Modal";

export default {
  mixins: [Modal],

  data() {
    return {
      sent: false,
      account: null,
      origin: "",
      message: "",
    };
  },

  mounted() {
    const vm = this;

    this.$on("modal-closed", () => {
      this.account = null;
    });

    this.$on("modal-opened", () => {
      this.sent = false;
      this.message = "";
      this.start();
    });

    this.$root.$on("open-message-modal", (account, origin) => {
      if (account) {
        vm.account = account;
      }

      if (origin) {
        vm.origin = origin;
      }

      vm.open();
    });
  },

  methods: {
    start() {
      axios
        .post(this.account.marketplace_start_message_url, {
          origin: this.origin,
        })
        .then((response) => {});
    },

    send($event, originalOnSubmit) {
      var promise = originalOnSubmit($event);

      var vm = this;

      promise
        .then(function (result) {
          vm.sent = true;
        })
        .catch(() => {});
    },
  },
};
</script>
